import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetches shared lists (projects, users, sprints) used by task forms.
export default function useMeta() {
  const [meta, setMeta] = useState({ projects: [], users: [], sprints: [] });

  useEffect(() => {
    Promise.all([
      api.get("/projects"),
      api.get("/users"),
      api.get("/sprints"),
    ])
      .then(([p, u, s]) => setMeta({ projects: p.data, users: u.data, sprints: s.data }))
      .catch(() => {});
  }, []);

  return meta;
}
